import * as React from "react";
import { Component } from "react";
import { Button } from "semantic-ui-react";
import * as uuid from "uuid";


export class FileButton extends Component {
    constructor(props) {
        super(props);

        this.id = uuid.v1();
        this.onChangeFile = this.onChangeFile.bind(this);
    }

    render() {
        return (
            <div>
                <Button
                    {...this.props}
                    as="label"
                    htmlFor={this.id}/>
                <input
                    hidden
                    id={this.id}
                    multiple
                    type="file"
                    accept=".csv"
                    onChange={this.onChangeFile}/>
            </div>
        );
    }

    onChangeFile() {
        const fileButton = document.getElementById(this.id);
        const file = fileButton ? fileButton.files[0] : null;
        if (this.props.onSelect) {
            this.props.onSelect(file);
        }
    }
}

export default FileButton;



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/Procurement/components/PriceUpdateForm/components/FileButton/index.js